import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { IconButton, InputAdornment, TextField, Typography } from '@material-ui/core';
import { Center, LoginButton } from '../Login/styles';
import { baseApi } from '../../services/utils';
import useStore from '../../services/hooks/useStore';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import styled from 'styled-components';

function useQuery(): URLSearchParams {
  return new URLSearchParams(useLocation().search);
}

const RESET_PATH = process.env.REACT_APP_RESET_PASSWORD_PATH ?? '/auth/recovery/confirm/';

const RecuperarSenha: React.FC = () => {
  const history = useHistory();
  const query = useQuery();
  const store = useStore();
  const token = query.get('token') || '';
  useEffect(() => {
    store.removeLoader();
  }, []);

  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const match = password && confirmPassword && password === confirmPassword;

  async function salvar(): Promise<void> {
    if (!token) {
      store.notificar('Link inválido ou expirado.');
      return;
    }
    if (!match) return;
    setSubmitting(true);
    try {
      await baseApi.post(RESET_PATH, { token, senha_nova: password });
      store.notificar('Senha alterada com sucesso!');
      history.push('/');
    } catch (err: any) {
      const msg =
        err?.response?.data?.detail ||
        err?.response?.data?.error ||
        'Não foi possível alterar a senha. Tente novamente.';
      store.notificar(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Center role="main" aria-labelledby="titulo-recuperar-senha">
      <img src="/images/logoHorizontal.png" alt="Logo Aquabit" width="258px" style={{ marginBottom: 10 }} />
      <Card>
        <Typography id="titulo-recuperar-senha" component="h1" style={{ fontSize: 32, fontWeight: 700, marginBottom: 8 }}>
          Redefinir senha
        </Typography>
        <Typography component="p" style={{ marginBottom: 20, textAlign: 'center', color: '#555' }}>
          Escolha uma nova senha para sua conta.
        </Typography>
        <TextField
          required
          fullWidth
          label="Nova senha"
          placeholder="Digite sua nova senha"
          type={show1 ? 'text' : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          inputProps={{ 'aria-label': 'Nova senha' }}
          variant="outlined"
          style={{ margin: '8px 0' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShow1((v) => !v)} edge="end" aria-label="mostrar/ocultar senha">
                  {show1 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          required
          fullWidth
          label="Confirmar nova senha"
          placeholder="Confirme sua nova senha"
          type={show2 ? 'text' : 'password'}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          inputProps={{ 'aria-label': 'Confirmação da nova senha' }}
          helperText=" "
          variant="outlined"
          style={{ margin: '8px 0' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShow2((v) => !v)} edge="end" aria-label="mostrar/ocultar confirmação">
                  {show2 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <LoginButton
          onClick={salvar}
          disabled={!password || !confirmPassword || !match || submitting}
          aria-label="Salvar nova senha"
          variant="contained"
          color="primary"
          style={{ marginTop: 16, maxWidth: 420, borderRadius: 12, padding: '12px 16px', fontWeight: 600 }}
        >
          Salvar nova senha
        </LoginButton>
        <div style={{ marginTop: 14, textAlign: 'center' }}>
          <Link to="/" style={{ color: '#059ce6', textDecoration: 'none', fontWeight: 500, display: 'inline-block', padding: '6px 8px' }}>
            Voltar para o login
          </Link>
        </div>
      </Card>
    </Center>
  );
};

export default RecuperarSenha;

const Card = styled.div`
  width: 420px;
  max-width: 90vw;
  background: #fff;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .MuiOutlinedInput-root {
    border-radius: 10px;
  }
`;

